<!--表格组件-->
<template>
  <div>
    <el-table
      ref="wovenBagManagementTable"
      :cell-style="{ 'text-align': 'center' }"
      :data="tableData"
      :header-cell-style="{ 'text-align': 'center' }"
      :height="510"
      border
      row-key="id"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <!-- 序列号/复选框 -->
      <el-table-column
        v-if="isSelectBtn"
        :reserve-selection="true"
        align="center"
        fixed="left"
        type="selection"
        width="50"
      />
      <el-table-column
        :label="$t('newOrder.SerialNumber')"
        align="center"
        fixed="left"
        type="index"
        width="70"
      >
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :align="item.align"
        :label="item.label"
        :min-width="item.minWidth"
        :prop="item.prop"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <!-- 状态 -->
          <div v-if="item.prop === 'recycleStatus'">
            <!--回收状态-->
            <div v-if="tableType === 1 || tableType === 2">
              <span v-if="scope.row[item.prop] === 1" style="color: #67c23a">{{
                $t('GlobalSetObj.Confirmed')
              }}</span>
              <!--已确认-->
              <span v-if="scope.row[item.prop] === 0" style="color: #e6a23c">{{
                $t('GlobalSetObj.Unconfirmed')
              }}</span>
              <!--未确认-->
              <!--<el-tag v-if="scope.row[item.prop] === 1" type="success" size="mini">{{ $t('GlobalSetObj.Confirmed') }}</el-tag>-->
              <!--已确认-->
              <!--<el-tag v-if="scope.row[item.prop] === 0" type="warning" size="mini">{{ $t('GlobalSetObj.Unconfirmed') }}</el-tag>-->
              <!--未确认-->
            </div>
          </div>
          <div v-else-if="item.prop === 'enableStatus'">
            <!--启用状态-->
            <div>
              <el-switch
                v-model="scope.row[item.prop]"
                :active-value="1"
                :inactive-value="0"
                active-color="#13ce66"
                disabled
                inactive-color="#ccc"
              />
            </div>
          </div>
          <div v-else-if="item.prop === 'flowCount'">
            <!--流出数量-->
            <div
              style="color: #00A551; cursor: pointer"
              @click="toDetailInOUtT(scope.row, scope.row[item.prop], item.isNewFlag, null)"
            >
              {{ scope.row.flowCount }}
            </div>
          </div>
          <div v-else-if="item.prop === 'returnedCount'">
            <!--已回收-->
            <div
              style="color: #24d634; cursor: pointer"
              @click="toDetailInOUtT(scope.row, scope.row[item.prop], item.isNewFlag, 2)"
            >
              {{ scope.row.returnedCount }}
            </div>
          </div>
          <div v-else-if="item.prop === 'unreturnedCount'">
            <!--未返还-->
            <div
              style="color: #f1bf44; cursor: pointer"
              @click="toDetailInOUtT(scope.row, scope.row[item.prop], item.isNewFlag, 0)"
            >
              {{ scope.row.unreturnedCount }}
            </div>
          </div>
          <div v-else-if="item.prop === 'unreturnedTotal'">
            <!--未返还总数-->
            <div
              style="color: red; cursor: pointer"
              @click="
                toDetailInOUtT(
                  scope.row,
                  scope.row[item.prop],
                  item.isNewFlag,
                  0,
                  8,
                  'unreturnedTotal'
                )
              "
            >
              {{ scope.row.unreturnedTotal }}
            </div>
          </div>
          <div v-else-if="item.prop === 'toBeConfirmedCount'">
            <!-- 待确认 -->
            <div
              style="cursor: pointer"
              @click="toDetailInOUtT(scope.row, scope.row[item.prop], item.isNewFlag, 1, 0)"
            >
              {{ scope.row.toBeConfirmedCount }}
            </div>
          </div>
          <div v-else>
            <div v-if="item.isClick">
              <span
                class="isClickStyle"
                @click="toDetailManage(scope.row, item.dataType, scope.row[item.prop], item.prop)"
              >{{ scope.row[item.prop] }}</span>
            </div>
            <div v-else>
              <div
                v-if="
                  scope.row[item.prop] !== null &&
                    scope.row[item.prop] !== undefined &&
                    scope.row[item.prop] !== ''
                "
              >
                {{ scope.row[item.prop] }}
              </div>
              <div v-else>/</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="tableType === 1 || tableType === 2 || tableType === 15"
        :label="$t('newOrder.operation')"
        :width="tableType === 1 ? 160 : 220"
        align="center"
        fixed="right"
        type="index"
      >
        <template slot-scope="scope">
          <div>
            <div v-if="tableType === 1">
              <el-button
                v-if="scope.row.recycleStatus === 0"
                size="mini"
                type="danger"
                @click="operationDelete(scope.row)"
              >
                {{ $t('placeOrder.Delete') }} </el-button><!--删除-->
            </div>
            <div v-if="tableType === 2">
              <el-button
                v-if="scope.row.recycleStatus === 0 && scope.row.receiveSiteId === userSiteId"
                size="mini"
                type="primary"
                @click="operationConfirm(scope.row)"
              >
                {{ $t('GlobalSetObj.RecyclingConfirmation') }} </el-button><!--回收确认-->
            </div>
            <div v-if="tableType === 15 && scope.row.unreturnedTotal > 0">
              <el-button size="mini" type="primary" @click="toRecyclingManagement(scope.row)">
                {{ $t('home.returnToRegistration') }} </el-button><!--返回登记-->
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 包裹详情-->
    <el-drawer
      :title="$t('collectionCenter.particulars')"
      :visible.sync="dialogVisible"
      center
      direction="ltr"
      size="1300px"
      @close="closeDrawer"
    >
      <quantityOutflow
        v-if="diffDialog === 1"
        :key="dataType"
        ref="votesDetails"
        :dataobj="dataObj"
        @call-parent-method="parentMethod"
      />
      <retureQuantity
        v-if="diffDialog === 2"
        :key="dataType"
        ref="votesDetails"
        :dataobj="dataObj"
        @call-parent-method="parentMethod"
      />
      <abnormalData
        v-if="diffDialog === 3"
        :key="dataType"
        ref="votesDetails"
        :dataobj="dataObj"
        @call-parent-method="parentMethod"
      />
    </el-drawer>
    <el-drawer
      :title="$t('collectionCenter.particulars')"
      :visible.sync="detailInOutDrawer"
      center
      direction="ltr"
      size="1300px"
      @close="closeDrawer"
    >
      <detailInOut
        v-if="detailInOutDrawer"
        ref="votesDetails"
        :detail-in-out-obj="detailInOutObj"
        @call-parent-method="parentMethod"
      />
    </el-drawer>
    <!-- 返回登记 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('home.returnToRegistration')"
      :visible.sync="returnDialog"
      width="500px"
    >
      <el-form
        ref="returnFormRef"
        :model="returnForm"
        :rules="exceptionRules"
        class="demo-ruleForm"
        label-width="auto"
        @submit.native.prevent
      >
        <el-form-item :label="$t('home.registerCount')" prop="registerCount" style="margin: 20px 0">
          <el-input
            v-model.trim="returnForm.registerCount"
            :maxlength="7"
            :placeholder="$t('GlobalSetObj.pleaseInput')"
            clearable
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small" @click="exceptionFormSubmit(1)"
        >{{ $t('GlobalSetObj.cancel') }}
        </el-button>
        <el-button
          size="small" type="primary" @click="exceptionFormSubmit(2)"
        >{{ $t('GlobalSetObj.confirm') }}
        </el-button>
      </div>
    </el-dialog>
    <!-- Tip -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('GlobalSetObj.tips')"
      :visible.sync="tipDialog"
      width="550px"
    >
      <div>
        <div class="flx-between">
          <div>
            <span>{{ $t('home.operationTotal') }}：</span>
            <span>{{ resultObj.total }}</span>
          </div>
          <div>
            <span>{{ $t('operationCenter.NumberOfSuccesses') }}：</span>
            <span>{{ resultObj.success }}</span>
          </div>
          <div>
            <span>{{ $t('operationCenter.NumberOfFailures') }}：</span>
            <span style="color: red">{{ resultObj.fail }}</span>
          </div>
        </div>
        <div v-if="resultObj.failList.length" style="height: 200px; overflow-y: auto">
          <div style="margin-top: 20px; margin-bottom: 8px">
            {{ $t('GlobalSetObj.ReasonForFailure') }}:
          </div>
          <div v-for="(item, index) in resultObj.failList" :key="index">
            <span>{{ index + 1 }}. </span>
            <span>{{ item.siteName }}: </span>
            <span>{{ item.reason }}</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          size="small" type="primary" @click="tipDialog = false"
        >{{ $t('GlobalSetObj.Close') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { bagRecycleReturnRegister } from '@/api/newExpressAPI';

export default {
  name: 'TableCmp',
  components: {
    quantityOutflow: () => import('../cmp/quantityOutflow.vue'),
    retureQuantity: () => import('../cmp/retureQuantity.vue'),
    abnormalData: () => import('../cmp/abnormalData.vue'),
    detailInOut: () => import('../cmp/detailInOut.vue')
  },
  props: {
    columnList: {
      type: Array,
      default() {
        return []; // 表格列
      }
    },
    isSelectBtn: {
      type: Boolean,
      default: false // 是否显示复选框
    },
    tableData: {
      type: Array,
      default() {
        return []; // 表格数据
      }
    },
    tableType: {
      type: Number,
      default: 1 // 1：我返回的 2：我回收的 3：领用明细 4：调整明细 5：流出明细 6：流入明细
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dataObj: {},
      diffDialog: 1,
      dataType: '',
      dialogVisible: false, // 详情弹窗
      detailInOutDrawer: false,
      detailInOutObj: {},
      returnDialog: false,
      returnForm: {
        registerCount: ''
      },
      exceptionRules: {
        registerCount: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' },
          { validator: this.validateQuantity, trigger: ['blur', 'change'] }
        ]
      },
      registerList: [],
      rowData: {},
      tipDialog: false,
      resultObj: {
        failList: []
      },
      unreturnedTotal: 0
    };
  },
  computed: {
    userSiteId() {
      return this.$store.state.user.siteId;
    }
  },
  methods: {
    exceptionFormSubmit(val) {
      if (val === 1) {
        this.returnDialog = false;
      } else {
        this.$refs['returnFormRef'].validate((valid) => {
          if (valid) {
            if (this.unreturnedTotal < this.returnForm.registerCount) {
              this.$message.error(this.$t('home.tip03'));
              return;
            }
            const data = {
              registerList: this.registerList,
              registerCount: this.returnForm.registerCount
            };
            this.returnDialog = false;
            bagRecycleReturnRegister(data).then((res) => {
              if (res.code === 200) {
                if (res.data) {
                  this.resultObj = res.data;
                  this.tipDialog = true;
                }
                this.toInFlowSearch();
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    closeDrawer() {
      this.dialogVisible = false;
    },
    parentMethod(arg) {
      this.dialogVisible = arg;
    },
    // 数据勾选
    handleSelectionChange(arr) {
      this.$emit('selectionChange', arr, 'selected');
    },
    // 删除
    operationDelete(row) {
      this.$emit('selectionChange', row, 'delete');
    },
    // 回收确认
    operationConfirm(row) {
      this.$emit('selectionChange', row, 'recyclingConfirmation');
    },
    // 调用流入明细分页查询
    toInFlowSearch() {
      const params = {
        type: 'in',
        startTime: this.startTime,
        endTime: this.endTime
      };
      this.$emit('toInFlowSearch', params);
      console.log('toInFlowSearch');
    },
    toRecyclingManagement(row) {
      console.log(row, 'toRecyclingManagement');
      this.returnDialog = true;
      this.returnForm.registerCount = row.unreturnedTotal || 0;
      this.unreturnedTotal = row.unreturnedTotal || 0;
      this.rowData = row;
      this.registerList = [
        {
          returnSiteId: row.targetSiteId,
          receiveSiteId: row.sentOutSiteId
        }
      ];
    },
    toDetailManage(row, dataType, val, prop, isNewFlag) {
      console.log(row, 'toDetailManage', dataType, val, prop);
      console.log(isNewFlag, 'isNewFlag');
      console.log(this.startTime, 'this.startTimethis.startTime');
      if (!val) return;
      this.dataType = new Date().getTime(); // 获取时间戳
      // 创建映射表维护 prop 和 diffDialog 的对应关系
      const diffDialogMap = {
        flowOutCount: 1,
        flowInCount: 1,
        recycledCount: 2,
        recyclingCount: 2,
        returnedCount: 2,
        returningCount: 2,
        abnormalAdjustCount: 3
      };

      // 初始化数据对象
      this.dataObj = {
        siteId: row.siteId,
        dataType,
        startTime: this.startTime,
        endTime: this.endTime
      };
      // 通过映射表设置 diffDialog（使用逻辑或保持默认值）
      this.diffDialog = diffDialogMap[prop] || this.diffDialog;
      // 统一控制弹窗显示
      this.dialogVisible = true;
    },
    toDetailInOUtT(row, val, isNewFlag, returnStatus, isJustFlag, protStr) {
      console.log(row, val, isNewFlag, 'toDetailManage', isJustFlag, returnStatus);
      if (isJustFlag === 0 && isNewFlag === 1) {
        setTimeout(() => {
          this.bus.$emit('toMyReturn', '2');
        }, 100);
      } else {
        if (val === 0) {
          return;
        }
        if (isNewFlag) {
          this.detailInOutObj = {
            type: isNewFlag === 1 ? 'out' : 'in',
            startTime: this.startTime,
            endTime: this.endTime,
            sentOutSiteId: row.sentOutSiteId,
            targetSiteId: row.targetSiteId,
            returnStatus: returnStatus
          };
          if (protStr) {
            this.detailInOutObj.endTime = null;
            this.detailInOutObj.startTime = null;
          }
          this.detailInOutDrawer = true;
        }
      }
    },
    // 取消勾选
    clearSelection() {
      this.$refs.wovenBagManagementTable.clearSelection();
    },
    // 自定义验证整数的方法（包括正整数、负整数和 0）
    validateQuantity(rule, value, callback) {
      const reg = /^[1-9]\d*$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error(this.$t('home.inputNumberdayu0')));
      }
    }
  }
};
</script>
<style scoped>
.isClickStyle {
  cursor: pointer;
  color: #00A551;
}
</style>
